import { useCallback } from 'react';

/**
 * Hook that calls /api/admin/translate (IT → EN) and returns the translated string.
 * Shows a toast/alert on failure.
 */
export const useTranslate = (API) => {
  return useCallback(async (text) => {
    const source = (text || '').trim();
    if (!source) return '';
    const res = await fetch(`${API}/admin/translate`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: source }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Traduzione fallita');
    }
    const data = await res.json();
    return data.translated || '';
  }, [API]);
};

/**
 * Hook that batch-translates a list of items via /api/admin/translate/batch.
 * `items` must be `[{ id, text }]` where ids are opaque identifiers chosen by the caller.
 * Returns `{ results: [{id, translated, ok}], ok, total }`.
 */
export const useBatchTranslate = (API) => {
  return useCallback(async (items) => {
    if (!items || items.length === 0) return { results: [], ok: 0, total: 0 };
    const res = await fetch(`${API}/admin/translate/batch`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Traduzione batch fallita');
    }
    return res.json();
  }, [API]);
};

export default useTranslate;
